import { render, staticRenderFns } from "./desc-list.vue?vue&type=template&id=3a5ddde0"
import script from "./desc-list.vue?vue&type=script&lang=js"
export * from "./desc-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports